import React from 'react';
import TransformationCard from '../transformations/TransformationCard';

const MappingUnique = ({ mappingData, onChange }) => {
  // mappingData shape: { condition: {...}, transformation: {...} }

  const handleTransformationChange = (newTransformation) => {
    onChange({
      ...mappingData,
      transformation: newTransformation,
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <TransformationCard
        transformationData={mappingData?.transformation}
        onTransformationChange={handleTransformationChange}
        isControlled={true} // Flag to tell card to use props instead of store
        fieldNamePrefix={['unique', 'transformation']}
      />
    </div>
  );
};

export default MappingUnique;
